export const CACHE_WRITE_METER_V107 = 'cache_creation_tokens';
export const MAX_TTL_MINUTES_V107 = 2147483647;

export const normalizeCacheTTLRowsV107 = (components = []) =>
  components.map((row) => {
    const legacyMinutes = {
      cache_creation_5m_tokens: 5,
      cache_creation_1h_tokens: 60,
    }[row.meter];
    return legacyMinutes
      ? {
          ...row,
          meter: CACHE_WRITE_METER_V107,
          attributes: { ...row.attributes, ttl_minutes: legacyMinutes },
        }
      : row;
  });

export const cacheTTLEnabledV107 = (components = []) =>
  components.some(
    (row) =>
      row.meter === CACHE_WRITE_METER_V107 &&
      Object.prototype.hasOwnProperty.call(row.attributes || {}, 'ttl_minutes')
  );

export const validTTLMinutesV107 = (value) => {
  const raw = String(value ?? '').trim();
  return (
    /^\d+$/.test(raw) &&
    Number.isSafeInteger(Number(raw)) &&
    Number(raw) > 0 &&
    Number(raw) <= MAX_TTL_MINUTES_V107
  );
};

export const toggleCacheTTLRowsV107 = (components, enabled, createRow) => {
  if (enabled) {
    const hasWriteRow = components.some(
      (row) => row.meter === CACHE_WRITE_METER_V107
    );
    const source = hasWriteRow ? components : [...components, createRow()];
    return source.map((row) =>
      row.meter === CACHE_WRITE_METER_V107
        ? {
            ...row,
            attributes: {
              ...row.attributes,
              ttl_minutes: row.attributes?.ttl_minutes ?? '',
            },
          }
        : row
    );
  }
  return components.map((row) => {
    if (row.meter !== CACHE_WRITE_METER_V107) return row;
    const attributes = { ...row.attributes };
    delete attributes.ttl_minutes;
    return { ...row, attributes, unit_amount_usd: '' };
  });
};

export const validateCacheTTLRowsV107 = (components, enabled, t) => {
  if (!enabled) return '';
  for (const row of components) {
    if (row.meter !== CACHE_WRITE_METER_V107) continue;
    if (!Object.prototype.hasOwnProperty.call(row.attributes || {}, 'ttl_minutes')) continue;
    if (
      !validTTLMinutesV107(row.attributes?.ttl_minutes) ||
      String(row.unit_amount_usd ?? '').trim() === ''
    ) {
      return t('models.commercial.cache_ttl.invalid');
    }
  }
  return '';
};
